import { createElement, ReactElement } from 'react';
import { HighlightableTextProps } from './types';

type HighlightableText = (string | ReactElement<'mark'>)[];

export const useHighlightableText = (props: HighlightableTextProps): string | HighlightableText => {
  if (!props.highlight) {
    return props.text;
  }
  // do not care for any special character
  const regex = new RegExp(
    `(${props.highlight.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&')})`,
    'gi'
  );
  return !regex.test(props.text)
    ? props.text
    : props.text.split(regex).map((part, index) =>
        regex.test(part) ? (
          <mark key={index} className={props.className} style={props.style}>
            {part}
          </mark>
        ) : (
          part
        )
      );
};
